export const SERVICES = [
  {
    slug: "penyelesaian-pinjol",
    key: "pinjol",
    short: "Pinjol",
    name: "Penyelesaian Pinjaman Online",
    index: "01",
    image: "/images/desk.jpg",
    imageAlt: "Seorang perempuan menelaah catatan keuangan di meja kerja",
    headline: "Punya Banyak Tagihan Pinjol? Mulai dengan Langkah yang Lebih Terarah.",
    description:
      "Kami membantu Anda memahami kondisi kewajiban pinjaman online, mengevaluasi pilihan penyelesaian, serta memperoleh penjelasan mengenai proses dan ketentuan pendampingan.",
    points: [
      "Evaluasi kondisi kewajiban pinjaman online.",
      "Penjelasan opsi penyelesaian yang mungkin tersedia.",
      "Pendampingan sesuai kesepakatan.",
      "Dokumentasi dan tindak lanjut sesuai hasil proses.",
    ],
    situations: [
      "Memiliki beberapa kewajiban pinjaman online.",
      "Mengalami kesulitan memenuhi jadwal pembayaran.",
      "Ingin memahami kemungkinan program penyelesaian.",
      "Membutuhkan penjelasan mengenai biaya, persyaratan, dan tahapan pendampingan.",
    ],
    cta: "Konsultasi Pinjol",
    seoTitle: "Jasa Konsultasi Penyelesaian Utang Pinjol | Mika Solution",
    seoDescription:
      "Butuh pendampingan menghadapi tagihan pinjaman online? Mika Solution membantu mengevaluasi kondisi utang dan memahami opsi penyelesaian sesuai ketentuan yang berlaku.",
    articles: ["cara-menghadapi-tagihan-pinjol", "apakah-utang-pinjol-bisa-dapat-potongan", "cara-memeriksa-legalitas-pinjol"],
  },
  {
    slug: "penyelesaian-kartu-kredit",
    key: "kartu-kredit",
    short: "Kartu Kredit",
    name: "Penyelesaian Kartu Kredit",
    index: "02",
    image: "/images/sign.jpg",
    imageAlt: "Dua orang meninjau dan menandatangani dokumen di meja",
    headline: "Tagihan Kartu Kredit Semakin Berat? Pahami Pilihan Anda.",
    description:
      "Pelajari opsi penyelesaian kewajiban kartu kredit melalui konsultasi dan pendampingan yang terarah sesuai kondisi akun dan kebijakan kreditur.",
    points: [
      "Pemetaan tagihan dan status akun kartu kredit.",
      "Penjelasan opsi penyelesaian sesuai kebijakan penerbit kartu.",
      "Pendampingan komunikasi sesuai kesepakatan.",
      "Dokumentasi hasil, termasuk bukti penyelesaian bila tercapai.",
    ],
    situations: [
      "Tagihan minimum terasa semakin berat dari bulan ke bulan.",
      "Memiliki lebih dari satu kartu kredit dengan tunggakan.",
      "Ingin memahami opsi penyelesaian sebelum mengambil keputusan.",
      "Membutuhkan kejelasan mengenai biaya dan tahapan pendampingan.",
    ],
    cta: "Konsultasi Kartu Kredit",
    seoTitle: "Konsultasi Penyelesaian Utang Kartu Kredit | Mika Solution",
    seoDescription:
      "Tagihan kartu kredit menumpuk? Konsultasikan kondisi akun Anda bersama Mika Solution untuk memahami opsi penyelesaian sesuai kebijakan penerbit kartu.",
    articles: ["tunggakan-kartu-kredit", "program-penyelesaian-utang-yang-perlu-diketahui", "periksa-sebelum-setuju-program"],
  },
  {
    slug: "penyelesaian-kta",
    key: "kta",
    short: "KTA",
    name: "Penyelesaian KTA",
    index: "03",
    image: "/images/meeting.jpg",
    imageAlt: "Konsultan dan klien berdiskusi sambil membaca dokumen",
    headline: "Butuh Kejelasan untuk Menyelesaikan Kewajiban KTA?",
    description:
      "Evaluasi kondisi kredit tanpa agunan Anda dan pahami kemungkinan langkah penyelesaian, persyaratan, serta biaya layanan sebelum mengambil keputusan.",
    points: [
      "Evaluasi kondisi dan riwayat pembayaran KTA.",
      "Penjelasan kemungkinan langkah penyelesaian.",
      "Penjelasan persyaratan dan biaya layanan di awal.",
      "Pendampingan dan dokumentasi sesuai kesepakatan.",
    ],
    situations: [
      "Cicilan KTA tidak lagi sesuai dengan kemampuan bayar.",
      "Sudah menunggak dan menerima penagihan.",
      "Ingin memahami opsi restrukturisasi atau penyelesaian.",
      "Membutuhkan pendamping untuk memahami dokumen dan ketentuan.",
    ],
    cta: "Konsultasi KTA",
    seoTitle: "Konsultasi Penyelesaian Utang KTA | Mika Solution",
    seoDescription:
      "Kesulitan membayar Kredit Tanpa Agunan? Evaluasi kondisi KTA Anda bersama Mika Solution dan pahami langkah penyelesaian, persyaratan, serta biaya layanan.",
    articles: ["memahami-kewajiban-kta", "beda-konsultasi-restrukturisasi-penyelesaian", "memilih-jasa-pendampingan-dengan-bijak"],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

export const PROGRAMS = [
  {
    key: "diskon",
    no: "01",
    title: "Program Lunas Diskon",
    stat: 50,
    statPrefix: "s.d.",
    statSuffix: "%",
    statLabel: "potongan dari total tagihan*",
    text: "Pelunasan sekaligus dengan potongan hingga 50% dari total tagihan, melalui negosiasi bunga, denda, dan nilai pelunasan bersama kreditur.",
    points: ["Negosiasi penghapusan bunga & denda", "Pembayaran langsung ke rekening resmi kreditur", "Pendampingan hingga surat keterangan lunas"],
    fit: "Cocok bila Anda memiliki dana untuk pelunasan sekaligus.",
    wa: "Halo Mika Solution, saya ingin berkonsultasi mengenai Program Lunas Diskon.",
  },
  {
    key: "restruktur",
    no: "02",
    title: "Program Restrukturisasi",
    stat: 5,
    statPrefix: "s.d.",
    statSuffix: " thn",
    statLabel: "tenor cicilan sesuai kemampuan*",
    text: "Penataan ulang kewajiban menjadi cicilan yang lebih ringan dan terjadwal, disesuaikan dengan kemampuan bayar bulanan Anda.",
    points: ["Analisa kemampuan bayar bulanan", "Pengajuan keringanan bunga & perpanjangan tenor", "Restrukturisasi tagihan multi-kartu / multi-kreditur"],
    fit: "Cocok bila Anda belum bisa melunasi sekaligus, tetapi mampu mencicil.",
    wa: "Halo Mika Solution, saya ingin berkonsultasi mengenai Program Restrukturisasi.",
  },
  {
    key: "balik-pokok",
    no: "03",
    title: "Program Pinjol Balik Pokok",
    stat: 100,
    statPrefix: "",
    statSuffix: "%",
    statLabel: "fokus pada pokok pinjaman*",
    text: "Penyelesaian pinjaman online dengan mengupayakan pembayaran sebesar pokok pinjaman, sementara bunga dan denda yang membengkak dinegosiasikan.",
    points: ["Pemetaan pokok vs bunga & denda tiap aplikasi", "Negosiasi pengembalian pokok pinjaman", "Pendampingan bila terjadi penagihan tidak beretika"],
    fit: "Cocok bila tagihan pinjol Anda membengkak jauh di atas pokok pinjaman.",
    wa: "Halo Mika Solution, saya ingin berkonsultasi mengenai Program Pinjol Balik Pokok.",
  },
];

export const PROGRAM_NOTE =
  "*Angka merupakan batas atau target yang dapat diupayakan, bukan jaminan. Hasil akhir bergantung pada status akun, kebijakan kreditur atau penyedia pinjaman, dan persetujuan pihak terkait.";

export const DISCLAIMER =
  "Ketersediaan program penyelesaian bergantung pada kondisi akun, kebijakan penyedia pinjaman, dan persetujuan pihak terkait. Konsultasi tidak menjamin potongan, cicilan tertentu, atau penghapusan kewajiban.";

export const STEPS = [
  {
    no: "01",
    title: "Konsultasi Awal",
    what: "Anda menceritakan gambaran kondisi kewajiban melalui WhatsApp atau formulir.",
    need: "Jenis kewajiban dan perkiraan total tagihan.",
    expect: "Penjelasan awal tentang layanan dan langkah berikutnya.",
  },
  {
    no: "02",
    title: "Evaluasi Kondisi",
    what: "Tim menelaah status akun, riwayat pembayaran, dan kemampuan bayar Anda.",
    need: "Ringkasan tagihan, nama kreditur, dan status tunggakan.",
    expect: "Pemetaan kondisi yang lebih jelas dan realistis.",
  },
  {
    no: "03",
    title: "Penjelasan Opsi",
    what: "Kami menjelaskan opsi yang mungkin tersedia beserta biaya dan ketentuan layanan.",
    need: "Waktu untuk berdiskusi dan bertanya.",
    expect: "Informasi tertulis sebelum Anda memutuskan apa pun.",
  },
  {
    no: "04",
    title: "Pendampingan Proses",
    what: "Bila Anda setuju, pendampingan berjalan sesuai kesepakatan tertulis.",
    need: "Dokumen pendukung dan komunikasi yang terbuka.",
    expect: "Kabar perkembangan secara berkala. Hasil bergantung pada persetujuan kreditur.",
  },
  {
    no: "05",
    title: "Dokumentasi & Tindak Lanjut",
    what: "Setiap hasil proses didokumentasikan dan ditindaklanjuti.",
    need: "Konfirmasi atas hasil yang disepakati.",
    expect: "Arsip dokumen dan panduan langkah selanjutnya.",
  },
];

export const VALUES = [
  { title: "Pendekatan Personal", text: "Setiap kondisi kami dengarkan dan evaluasi secara individual, bukan dengan satu solusi untuk semua." },
  { title: "Transparansi Proses", text: "Biaya, tahapan, dan ketentuan dijelaskan di awal, sebelum Anda mengambil keputusan." },
  { title: "Pendampingan Terarah", text: "Setiap langkah memiliki tujuan dan dokumentasi yang jelas, dari konsultasi hingga tindak lanjut." },
  { title: "Privasi & Kerahasiaan", text: "Data Anda hanya digunakan untuk keperluan konsultasi dan pendampingan, tidak untuk dibagikan." },
];
